import { FAVORITES } from '@common/Filters/constants';
import { getAvailableInBrandGroup } from '@common/Filters/helpers';
import { useConfig } from '@common/Hooks/useConfig';
import { isFeatureActive } from '@helpers/index';

export const useBrandsGroupFilter = (brandGroupsData, brands) => {
    const config = useConfig();

    const hasBrandGroupsFilter = brandGroupsData?.some(({ brandIds }) => (
        getAvailableInBrandGroup(brandIds, brands).length > 0
    ));
    const hasFavourites = brandGroupsData
        ?.some(({ brandgroupId, brandIds }) => brandgroupId === FAVORITES && brandIds.length > 0);
    const isHighlightsFilterFeatureActive = isFeatureActive('PLT-40756-reactivate-highlighted-filter-in-brands', config);

    const hasHighlightedFilters = (isHighlightsFilterFeatureActive && hasBrandGroupsFilter) || hasFavourites;

    return {
        hasHighlightedFilters,
        hasFavourites
    };
};
